import { useState, useEffect } from "react";
import { ColumnsType } from "antd/es/table";
import { Table, message } from "antd";
import { useLockFn } from "ahooks";
import { TradeTypeEnum } from "@/types/FmsEnums";
import { AppDrawer } from "@/components/YhDrawer";
import { uploadDataModel } from "./uploadDataModel";
import { useDetailModel } from "../detailModel";
import { useNavModel } from "@/model/navModel";
import { InvoiceBill, InvoiceMateFields } from "@/views/invoice/manage/InvoiceManageTypes";
import { invoiceManageService } from "@/views/invoice/manage/InvoiceManageService";
import SelectInvoice from "./SelectInvoice";
import BillDetailRender from "@/views/invoice/manage/BillDetailRender";

type labelsType = {
    label: string;
    value: string;
    amount: string;
}

type returnMsgType = {
    code: string;
    invoiceNum: string;
}

export function InvoiceMate() {

    const { addNav, closeNav } = useNavModel();
    const { selectedDataMate } = useDetailModel();
    const { dataSource, invoiceMateVisible, setInvoiceMateVisible } = uploadDataModel();

    const [data, setData] = useState<InvoiceBill[]>([]);

    // 提供回调函数
    const selectInvoiceNum = (msg: returnMsgType) => {
        console.log('子组件传过来的数据:', JSON.stringify(msg))
        selectedDataMate.map(e => {
            if (e.code == msg.code) {
                e.invoiceNum = msg.invoiceNum;
            }
        });
    }

    const columns: ColumnsType<InvoiceBill> = [
        {
            title: '序号',
            align: "center",
            width: 40,
            render: (v, r, i) => i + 1
        },
        {
            title: '单据编号',
            dataIndex: 'tradeCode',
            align: "center",
            width: 140,
            ellipsis: true,
            render: (t, r) => BillDetailRender(t, r.branch ?? '', r.tradeCode ?? '', r.tradeTypeCode ?? '')
        },
        {
            title: '单据金额',
            dataIndex: 'billAmount',
            width: 100,
            ellipsis: true,
            align: "center",
            // render: (text, record) => (
            //     record.tradeTypeCode === TradeTypeEnum.SALE_RETURN ||
            //     record.tradeTypeCode === TradeTypeEnum.PURCHASE_RETURN ||
            //     record.tradeTypeCode === TradeTypeEnum.BILL_FAVORABLE) ? Math.abs(text) : text
        },
        {
            title: '发票号码',
            dataIndex: 'invoiceNum',
            align: "center",
            ellipsis: true,
            render: (v, r, i) => {
                let options: labelsType[] = [];
                dataSource.map(e => {
                    options.push({
                        label: e.invoiceNum ?? '',
                        value: e.invoiceNum ?? '',
                        amount: e.amount ?? '',
                    });
                });
                return <SelectInvoice bill={r} options={options} returnMsg={selectInvoiceNum} />
            },
        }
    ]

    useEffect(() => {
        setData(selectedDataMate);
    }, [selectedDataMate])

    const onOk = useLockFn(async () => {
        try {
            let mate: InvoiceMateFields[] = [];
            selectedDataMate.map(e => {
                if (e.invoiceNum != null) {
                    let data: InvoiceMateFields = {
                        billCode: e.code,
                        invoiceNums: e.invoiceNum.split(","),
                        partnerTypeCode: e.partnerTypeCode,
                        partnerCode: e.partnerCode,
                        partnerName: e.partnerName,
                        invoiceTypeCode: e.invoiceTypeCode,
                        invoiceTypeName: e.invoiceTypeName,
                    }
                    mate.push(data);
                }
            });
            let insertRet = await invoiceManageService.invoiceUploadMate(mate);
            if (insertRet) {
                message.success("操作成功!");
                setInvoiceMateVisible(false);
                closeNav("14-1-2")
                addNav("14-1-1");
            }
            else {
                message.error("操作失败!");
            }
        }
        catch (e) {
            console.log("系统错误" + e);
        }
    })

    const onCancel = () => {
        setInvoiceMateVisible(false);
    }

    return (
        <AppDrawer
            {...{
                title: "发票匹配",
                visible: invoiceMateVisible,
                closable: true,
                onOk,
                onCancel,
                showFooter: true,
                width: 640,
                okText: "保存",
                cancelText: "返回"
            }}
        >
            <Table
                rowKey={record => record.key}
                columns={columns}
                dataSource={data}
                pagination={{
                    showTotal: (total: number) => `共${total}条`,
                    position: ["bottomCenter"],
                }}
            />
        </AppDrawer>
    )
}

